import { createApp } from 'vue'
import App from './App.vue'
import router, { retryPendingSessionNavigation } from './router'
import store from './store'
import { registerNativeBridge } from './utils/nativeBridge'
import './assets/scss/index.scss'
import { createHead } from '@unhead/vue/client'
import PrimeVue from 'primevue/config'
import ConfirmationService from 'primevue/confirmationservice'
import 'primevue/resources/themes/lara-light-blue/theme.css'
import 'primevue/resources/primevue.min.css'
import 'primeicons/primeicons.css'

const app = createApp(App)
const head = createHead()

app.use(store)
registerNativeBridge(store, {
  onSessionReady: retryPendingSessionNavigation,
})

app.use(router)
app.use(PrimeVue)
app.use(ConfirmationService)
app.use(head)

document.body.addEventListener('touchstart', function () {})

const mountApp = () => app.mount('#app')
router.isReady().then(mountApp, mountApp)
